import styles from './index.module.scss';
import EFPicture from '@elem/compCommon/EFPicture';
import { PictureType } from '@elem/compCommon/EFPicture';
import { SectionProProps } from '../SectionPro';
import SectionPro from '../SectionPro';

type ImgSectionProProps = Omit<SectionProProps, 'children'> & {
    src: string;
    srcMobile?: string;
    children?: any;
};

const ImgSectionPro: React.FC<ImgSectionProProps> = (props: ImgSectionProProps) => {
    return (
        <SectionPro className={styles.ImgSectionPro} label={props.label} title={props.title} desc={props.desc}>
            <EFPicture src={props.src} srcMobile={props.srcMobile} className="section-pro-img" />
        </SectionPro>
    );
};

export default ImgSectionPro;
